// Widget Scripts
// import cardWidget from './js/widgets/cardWidget.js';
import slider from './js/widgets/slider';
import multiEvents from './js/widgets/multiEvents';
import * as socialFeed from './js/widgets/socialFeed';
import hotButtonsWidget from './js/widgets/hotButtonsWidget';
import seoWidget from './js/widgets/seoWidget';
import activitiesWidget from './js/widgets/activitiesWidget';
import mainSponsorsWidget from './js/widgets/mainSponsorsWidget';
import sponsors from './js/widgets/sponsors';
import footerLogoWidget from './js/widgets/footerLogoWidget';

// Custom Theme Scripts
import './js/localjs';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(() => {
    slider();
    multiEvents();
    socialFeed.facebookfeed(true);
    socialFeed.instafeed(false);
    seoWidget();
    hotButtonsWidget();
    mainSponsorsWidget();
    sponsors();
    activitiesWidget();
  });
}
$(document).ready(() => {
  footerLogoWidget();
});
